(() => {
  'use strict';
  if (window.spNewsletterUI) { window.spNewsletterUI.init(); return; }
  const mounted = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mountHeader(root) {
    const bar = root.querySelector('.sp-newsletter-header__bar');
    const toggle = root.querySelector('[data-sp-newsletter-toggle]');
    const menu = root.querySelector('[data-sp-newsletter-menu]');
    const close = root.querySelector('[data-sp-newsletter-close]');
    if (!bar || !toggle || !menu || !close) return () => {};
    const abort = new AbortController();
    const opts = { signal: abort.signal };
    let previousOverflow = '', locked = false, pending = 0;
    function restore() {
      if (locked) { document.documentElement.style.overflow = previousOverflow; locked = false; }
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
    }
    function dismiss() { if (menu.open) menu.close(); restore(); toggle.focus({ preventScroll: true }); }
    toggle.addEventListener('click', () => {
      if (menu.open) { dismiss(); return; }
      previousOverflow = document.documentElement.style.overflow;
      menu.showModal();
      document.documentElement.style.overflow = 'hidden'; locked = true;
      toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('aria-label', 'Close menu');
      close.focus({ preventScroll: true });
    }, opts);
    close.addEventListener('click', dismiss, opts);
    menu.addEventListener('close', restore, opts);
    menu.addEventListener('cancel', event => { event.preventDefault(); dismiss(); }, opts);
    menu.addEventListener('click', event => {
      const box = menu.getBoundingClientRect();
      if (event.target === menu && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dismiss();
      else if (event.target.closest('a')) dismiss();
    }, opts);
    function updateTone() {
      pending = 0;
      const hero = document.querySelector('[data-sp-newsletter-hero]');
      const rect = hero && hero.getBoundingClientRect();
      const overHero = rect && rect.top <= 0 && rect.bottom > bar.getBoundingClientRect().bottom;
      root.dataset.tone = overHero ? (hero.dataset.headerTone || 'light') : 'dark';
    }
    function schedule() { if (!pending) pending = requestAnimationFrame(updateTone); }
    window.addEventListener('scroll', schedule, { passive: true, signal: abort.signal });
    window.addEventListener('resize', schedule, opts);
    document.addEventListener('shopify:section:load', schedule, opts);
    document.addEventListener('shopify:section:unload', schedule, opts);
    updateTone();
    return () => { abort.abort(); if (pending) cancelAnimationFrame(pending); if (menu.open) menu.close(); restore(); };
  }
  function mountHero(root) {
    const video = root.querySelector('video');
    const button = root.querySelector('[data-sp-newsletter-video-toggle]');
    if (!video || !button) return () => {};
    const abort = new AbortController();
    const opts = { signal: abort.signal };
    const speed = Math.max(.25, Math.min(1.5, Number(root.dataset.speed) || .5));
    let start = 0, end = 0, userPaused = false, visible = true, destroyed = false;
    function syncButton() { button.textContent = video.paused ? 'Play video' : 'Pause video'; }
    function play() {
      if (destroyed || motion.matches || userPaused || !visible || document.hidden) return;
      const attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(syncButton);
    }
    function configure() {
      if (!Number.isFinite(video.duration) || video.duration <= 0) return;
      video.muted = true; video.playbackRate = speed;
      start = Math.min(Math.max(0, Number(root.dataset.start) || 0), Math.max(0, video.duration - .1));
      const requestedEnd = Number(root.dataset.end) || video.duration;
      end = Math.min(video.duration, Math.max(start + .1, requestedEnd));
      video.currentTime = start;
      button.hidden = motion.matches;
      play(); syncButton();
    }
    function applyMotion() {
      button.hidden = motion.matches;
      if (motion.matches) { video.pause(); root.dataset.videoReady = 'false'; }
      else { if (video.readyState >= 2) root.dataset.videoReady = 'true'; play(); }
    }
    video.addEventListener('loadedmetadata', configure, opts);
    video.addEventListener('loadeddata', () => { if (!motion.matches) root.dataset.videoReady = 'true'; }, opts);
    video.addEventListener('timeupdate', () => { if (end && video.currentTime >= end) { video.currentTime = start; play(); } }, opts);
    video.addEventListener('ended', () => { video.currentTime = start; play(); }, opts);
    video.addEventListener('play', syncButton, opts);
    video.addEventListener('pause', syncButton, opts);
    video.addEventListener('error', () => { root.dataset.videoReady = 'false'; button.hidden = true; }, opts);
    button.addEventListener('click', () => { userPaused = !video.paused; if (userPaused) video.pause(); else play(); }, opts);
    document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); }, opts);
    motion.addEventListener('change', applyMotion, opts);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (!visible) video.pause(); else play(); });
    observer.observe(root);
    if (video.readyState >= 1) configure();
    applyMotion();
    return () => { destroyed = true; observer.disconnect(); abort.abort(); video.pause(); };
  }
  function init() {
    for (const [root, cleanup] of mounted) { if (!root.isConnected) { cleanup(); mounted.delete(root); } }
    document.querySelectorAll('[data-sp-newsletter-header],[data-sp-newsletter-hero]').forEach(root => {
      if (!mounted.has(root)) mounted.set(root, root.hasAttribute('data-sp-newsletter-header') ? mountHeader(root) : mountHero(root));
    });
  }
  window.spNewsletterUI = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of mounted) if (event.target.contains(root)) { cleanup(); mounted.delete(root); }
  });
})();
